import 'url-search-params-polyfill';
import algoliasearch from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { configure, hits, pagination, searchBox, stats } from 'instantsearch.js/es/widgets';
import { addClass, removeClass } from '../../tools/helpers';

const CLASSNAME_PAGINATION = '.pagination';
const SEARCH_INPUT_SELECTOR = 'input[name="korridor_b_de[query]"]';
const RESULTS_CONTAINER_ID = 'hits';

class AlgoliaSearch {
  constructor(options = {}) {
    this.element = options.element;
    this.searchIndexName = this.element.dataset.searchIndexName || '';
    this.searchInputPlaceholder = this.element.dataset.searchInputPlaceholder || '';
    this.searchInputTitle = this.element.dataset.searchInputTitle || '';
    this.searchFormSubmit = this.element.dataset.searchFormSubmit || '';
    this.searchResultMsg = this.element.dataset.searchResultMsg || '';
    this.searchResultMsgEmpty = this.element.dataset.searchResultMsgEmpty || '';

    this.searchBar = document.querySelector(SEARCH_INPUT_SELECTOR);
    this.searchResultsContainer = document.getElementById(RESULTS_CONTAINER_ID);
    this.pagination = document.querySelector(CLASSNAME_PAGINATION);
    this.params = {};
    this.searchParams = new URLSearchParams(window.location.search);
    this.params.query = this.searchParams.get('korridor_b_de[query]') || null;
  }

  init() {
    const searchClient = algoliasearch('QW9D9NG1K1', 'cd12cec50c14b1968d6f0c20c1547a05');
    const search = instantsearch({
      searchClient,
      indexName: this.searchIndexName,
      routing: true,
    });

    search.addWidgets(this.getSearchWidgets());
    search.on('render', this.handleRender.bind(this));
    search.start();
  }

  getSearchWidgets() {
    return [
      configure({ attributesToSnippet: ['description', 'content'] }),
      searchBox({
        container: '#searchbox',
        searchAsYouType: false,
        showReset: false,
        placeholder: this.searchInputPlaceholder,
      }),
      stats({
        container: '#stats-hits',
        templates: {
          text: `{{nbHits}} ${this.searchResultMsg}`,
        },
      }),
      hits({
        container: '#hits',
        templates: {
          empty: this.searchResultMsgEmpty,
          item: `
            <a href="{{ url }}">
            <h3>{{ title }}</h3>
            <h4><svg class="{{ action }}"><use xlink:href="#svgsymbol-icon-download"></use></svg>{{ url }}</h4>
            <p class="description">{{#helpers.snippet}}{ "attribute": "description" }{{/helpers.snippet}}</p>
            <p class="content">{{#helpers.snippet}}{ "attribute": "content" }{{/helpers.snippet}}</p>
          </a>
      `,
        },
      }),
      pagination({
        container: '#pagination',
      }),
    ];
  }

  handleRender() {
    const numberOfHits = this.searchResultsContainer.getElementsByClassName('ais-Hits-item').length;
    this.togglePagination(numberOfHits);
    this.searchBar.value = document.querySelector('.ais-SearchBox-input').value || '';
    document.querySelector('.ais-SearchBox-input').setAttribute('title', this.searchInputTitle);
    document.querySelector('.ais-SearchBox-submit').setAttribute('title', this.searchFormSubmit);
  }

  togglePagination(numberOfHits) {
    if (numberOfHits > 0) {
      removeClass(this.pagination, 'hidden');
    } else {
      addClass(this.pagination, 'hidden');
    }
  }
}

export default AlgoliaSearch;
